<template>
  <div class="feed-list">
    <FeedListItem
      v-for="(d, i) in dynamicList"
      :key="'dynamic-' + d.id + '-' + i"
      class="dynamic-one"
      :info="d"
      :isSquare="!playerUuid"
      @updatedynamic="updateDynamic(i, $event)"
      @deletedynamic="deleteDynamic(i)"
      @opendetail="openDetail"
    />
    <slot v-if="!isLoading && !dynamicList.length" name="empty">
      <div class="empty-data">
        <img
          class="empty-img"
          src="~@/assets/image/background/empty-dynamic.png"
        />
        <span class="empty-text">{{$t('upgrade_page_views_user_feed_feed_list_284')}}</span>
      </div>
    </slot>
    <div ref="dynamic_bottom" class="dynamic-bottom"></div>
    <div v-show="isLoading" class="loading-wrap">
      <i class="el-icon-loading" />
    </div>
    <FeedDetail
      v-model="showDetail"
      :isSquare="!playerUuid"
      :momentId="momentId"
    />
  </div>
</template>
<script>
import FeedDetail from './feed-detail';
import FeedListItem from './feed-list-item';

export default {
  components: {
    FeedDetail,
    FeedListItem
  },
  props: {
    playerUuid: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: '/moment/moment/list'
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 是否推荐
    isRecommend() {
      return this.url === '/moment/square/recommend';
    }
  },
  data() {
    return {
      isLoading: false,
      momentId: 0,
      dynamicList: [],
      finished: false,
      showDetail: false,
      lastRecommendResult: {}, //上一次请求回来的动态数据
      pageIndex: 1,
      pageSize: 6,
      total: null,
      params: {},
      excludeIds: []
    };
  },
  watch: {
    playerUuid(newVal) {
      if (newVal) {
        this.dynamicList = [];
        this.getDefaultList();
      }
    },
    isShow: {
      handler: function(nVal) {
        if (nVal) {
          this.getDefaultList();
        }
      },
      immediate: true
    }
  },
  created() {},
  mounted() {
    this.addScrollEventListener();
  },
  beforeDestroy() {
    this.removeScrollEventListener();
  },
  methods: {
    addScrollEventListener() {
      /**
       * 陪陪详情页动态显示弹窗滚动
       */
      this.scrollDom = document.getElementById('page-main');
      if (this.scrollDom)
        this.scrollDom.addEventListener('scroll', this.getMoreList);
    },
    removeScrollEventListener() {
      if (this.scrollDom)
        this.scrollDom.removeEventListener('scroll', this.getMoreList);
      if (this.timer) clearTimeout(this.timer);
    },
    openDetail({ id }) {
      this.showDetail = true;
      this.momentId = id;
    },
    getMoreList(ev) {
      // console.log(ev.target);
      const { scrollTop, clientHeight, scrollHeight } = ev.target;
      console.log('getMore', scrollTop, clientHeight, scrollHeight);
      if (scrollTop + clientHeight + 150 >= scrollHeight && this.isShow) {
        this.getList();
        // if (this.isRecommend) {
        //   if (
        //     !this.total ||
        //     (this.pageIndex - 1) * this.pageSize <= this.total
        //   ) {
        //     this.getList();
        //   }
        // } else {
        //   this.getList();
        // }
      }
    },

    // getMoreList(ev) {
    //   console.log('getMoreList',ev);
    //   if (this.finished) return;
    //   const dom = this.$refs.dynamic_bottom;
    //   const time = Date.now();
    //   if (dom && (!this.lastTime || time - this.lastTime > 200)) {
    //     this.lastTime = time;
    //     if (this.timer) clearTimeout(this.timer);
    //     this.offsetDom();
    //     this.timer = setTimeout(() => {
    //       console.log('setTimeout',this.$refs.dynamic_bottom);
    //       this.offsetDom();
    //       this.timer = null;
    //     }, 300);
    //   }
    // },
    // offsetDom() {
    //   const dom = this.$refs.dynamic_bottom;
    //   console.log(dom.getBoundingClientRect().y,window.screen.height,dom.getBoundingClientRect().y < window.screen.height - 150);
    //   if (!dom) return;
    //   if (dom.getBoundingClientRect().y < window.screen.height - 150) {
    //     this.getList();
    //   }
    // },
    updateDynamic(i, info) {
      this.dynamicList.splice(i, 1, info);
    },
    deleteDynamic(i) {
      this.dynamicList.splice(i, 1);
    },
    getDefaultList() {
      if (!this.playerUuid && this.url === '/moment/moment/list') return;
      this.dynamicList = [];
      if (this.isRecommend) {
        this.pageIndex = 1;
        this.lastRecommendResult = {};
        this.total = null;
        this.excludeIds = [];
        this.params = {
          pageSize: this.pageSize,
          max: this.lastRecommendResult.max,
          mix: this.lastRecommendResult.mix,
          seed: this.lastRecommendResult.seed,
          pageIndex: this.pageIndex,
          excludeIds: this.excludeIds
        };
      } else {
        this.params = {
          size: 5,
          userUuid: this.playerUuid
        };
      }
      this.getList();
    },
    getList() {
      if (this.isLoading || this.finished || !this.params) return;
      this.isLoading = true;
      return this.$http
        .post(this.url, this.params)
        .then(({ data }) => {
          if (this.isRecommend) {
            if (
              data &&
              data.momentVo &&
              data.momentVo.pageContent &&
              data.momentVo.pageContent.length
            ) {
              this.dynamicList = this.dynamicList.concat(
                data.momentVo.pageContent
              );
            } else {
              this.finished = true;
            }
            this.lastRecommendResult = data;
            // this.pageIndex += 1;
            this.excludeIds =
              this.dynamicList && this.dynamicList.length
                ? this.dynamicList.map(item => {
                    return item.id.toString();
                  })
                : [];
            this.params = {
              pageSize: this.pageSize,
              max: this.lastRecommendResult.max,
              mix: this.lastRecommendResult.mix,
              seed: this.lastRecommendResult.seed,
              pageIndex: this.pageIndex,
              excludeIds: this.excludeIds
            };
            this.total = data.momentVo.totalRemain;
          } else {
            if (data && data.length) {
              this.dynamicList = this.dynamicList.concat(data);
              this.params.lastId = data[data.length - 1].createTime;
            } else {
              this.finished = true;
            }
          }
          this.isLoading = false;
          this.$emit('getFeed', this.dynamicList);
        })
        .catch(err => {
          console.log(err);
          this.$emit('getFeed', this.dynamicList);
          this.isLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.dynamic-bottom {
  height: 1px;
  width: 100%;
}
.empty-data {
  @include flex(center, center, column);
  padding-top: 78px;
  .empty-img {
    height: 90px;
    margin-bottom: 2px;
  }
  .empty-text {
    font-size: 13px;
    line-height: 18px;
    color: $color-gray-3;
  }
}
.loading-wrap {
  @include flex;
  font-size: 24px;
  padding-top: 20px;
  height: 300px;
}
</style>
